import { Box, Container, Typography } from "@mui/material";
import maxLogo from "../../../assets/max-messenger-sign-logo.svg"

export const IntermarkFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'sticky',
        top: '100vh',
        py: 2,
        mb: 0.5,
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, flexGrow: 0, flexShrink: 0 }}>
          <Typography variant="body3" color="text.secondary">
            Связаться с нами:
          </Typography>
          <Box
            component="a"
            href="https://max.ru/u/f9LHodD0cOKQVeF_LGxTS-TTUKn___I7ZMbhayASBghbJUBSy7E_qIkFbQc"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              transition: 'transform 0.2s ease-in-out', 
              '&:hover': {
                transform: 'scale(1.1)', 
              },
              '&:active': {
                transform: 'scale(0.95)',
              }
            }}
          >
            <Box
              component="img"
              src={maxLogo}
              alt="MAX"
              sx={{ height: 45 }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};